<template>
  <div id="app" class="wrapper">
    <div class="hdr">
      <div class="hdr-wrapper">
        <router-link to="/">
          <div class="logo">
            <img
              src="/assets/img/logo.png"
              alt="MC Remote"
              class="logo-image"
            />
          </div>
        </router-link>
        <div class="title" v-if="user">
          <h1>{{ user.apartmentName }}</h1>
          <span class="user-num">
            {{ user.roomNo }}号室&nbsp;{{ role2Ja(user.role) }}様
          </span>
        </div>
        <ul class="hdr-button">
          <li class="hdr-button-item">
            <a href="/docs/faq.html" target="_blank">
              <button class="bt">
                <img
                  src="/assets/img/bt_hdr_faq.png"
                  alt="よくあるご質問"
                  class="hdr-button-image"
                />
              </button>
            </a>
          </li>
          <li class="hdr-button-item">
            <button
              class="bt"
              @click="logOut"
              v-show="
                $route.path != '/login' && $route.path != '/login-magic-number'
              "
            >
              <img
                src="/assets/img/bt_hdr_logout.png"
                alt="ログアウト"
                class="hdr-button-image"
              />
            </button>
          </li>
        </ul>
      </div>
    </div>
    <!--/.hdr-->
    <GlobalNavi
      v-on:logout="logOut"
      v-show="$route.path != '/login' && $route.path != '/login-magic-number'"
    />
    <router-view></router-view>

    <div class="ftr">
      <div class="ftr-top-wrapper">
        <ul class="ftr-link">
          <li class="ftr-link-item">
            <a href="/docs/policy.html" target="_blank">個人情報保護方針</a>
          </li>
          <li class="ftr-link-item">
            <a href="/docs/kiyaku.html" target="_blank">ご利用規約</a>
          </li>
        </ul>
      </div>
      <div class="ftr-bottom-wrapper">
        <div class="copyright">
          Copyright &copy; 2020 Zoom Communications, Inc.
        </div>
      </div>
    </div>
    <!--/.ftr-->
  </div>
  <!--/.wrapper-->
</template>

<script>
import GlobalNavi from "@/components/GlobalNavi.vue";

export default {
  components: { GlobalNavi },

  name: "app",
  mounted: function() {
    var routeInstance = this.$route;
    console.log("+++++top mount");
    this.createTitleDesc(routeInstance);
    // window.onpopstate = function(event) {
    //   document.body.style.overflow = "auto";
    //   console.log(
    //     "location: " +
    //       document.location +
    //       ", state: " +
    //       JSON.stringify(event.state),
    //   );
    // };
  },
  computed: {
    user() {
      return this.currentUser;
    },
    showAdminBoard() {
      return true;
      // if (this.currentUser && this.currentUser.role) {
      //   // eslint-disable-next-line
      //   console.log(this.currentUser);
      //   return this.currentUser.role == "Admin";
      // }

      // return false;
    },
    showModeratorBoard() {
      return true;
      // if (this.currentUser && this.currentUser.roles) {
      //   return this.currentUser.roles.includes("ROLE_MODERATOR");
      // }

      // return false;
    },
  },
  watch: {
    // eslint-disable-next-line
    $route(routeInstance, from) {
      this.createTitleDesc(routeInstance);
    },
  },
  data() {
    return {
      defaultIndex: "/",
    };
  },
  methods: {
    role2Ja: function(role) {
      const roleNames = {
        Admin: "管理者",
        ExternalParty: "外部関係者",
        Chairman: "理事長",
        Director: "理事",
        OwnedResident: "区分所有者",
        OwnedNonResident: "外部オーナー",
        RentResident: "賃借人",
        Others: "その他",
      };
      return roleNames[role];
    },
    createTitleDesc: function(routeInstance) {
      // タイトルを設定
      if (routeInstance.meta.title) {
        var setTitle = routeInstance.meta.title + " | MC Remote";
        document.title = setTitle;
      } else {
        document.title = "MC Remote";
      }

      // if (routeInstance.meta.desc) {
      //   var setDesc = routeInstance.meta.desc + " | MC Remote";
      //   document
      //     .querySelector("meta[name='description']")
      //     .setAttribute("content", setDesc);
      // } else {
      //   document
      //     .querySelector("meta[name='description']")
      //     .setAttribute("content", "description is not set");
      // }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.$router.push({ path: key });
    },
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

.el-menu--horizontal > .el-menu-item.dock-right {
  float: right;
}
.title-margin {
  margin: 55px 0 20px;
}
</style>
